/**
 * App-Konfiguration
 * 
 * Zentrale Konfigurationsdatei für Environment-abhängige Einstellungen.
 * Werte werden aus Vite Environment Variables (.env.development / .env.production) geladen.
 */

export const config = {
  /** API Base URL (für nicht-proxied Requests) */
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:5000',

  /** App-Name */
  appName: import.meta.env.VITE_APP_NAME || 'GOKI Image',

  /** Environment (development/production) */
  env: import.meta.env.VITE_APP_ENV || 'development',

  /** Development-Modus? */
  isDevelopment: import.meta.env.DEV,

  /** Production-Modus? */
  isProduction: import.meta.env.PROD,

  /** Supabase URL (aus Backend Config oder Vite Env) */
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || '',

  /** Supabase Anon Key (aus Backend Config oder Vite Env) */
  supabaseKey: import.meta.env.VITE_SUPABASE_KEY || '',
} as const;

// Export API_BASE_URL for convenience (used by public API)
export const API_BASE_URL = config.apiUrl;

export default config;


